import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import BusinessPlanScreen from "../plan/BusinessPlanScreen";
import { BusinessModuleUIRenderer } from "./BusinessModuleUIRenderer";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessTasksModule"
>;

export const BusinessModuleScreen = observer((props: Props) => {
  const businessModuleUid = props.route.params.businessModuleUid;

  return (
    <BusinessPlanScreen {...props}>
      <BusinessModuleUIRenderer uid={businessModuleUid} />
    </BusinessPlanScreen>
  );
});

export default BusinessModuleScreen;
